module.exports = __webpack_public_path__ + "paywall-pop-up-9abdcbe5bd789dbdf5d8.png";